import * as React from "react";

export const commonHighContrastBackgroundHoverFocus: React.CSSProperties = {
  background: "Highlight",
};

export const commonHighContrastColorHoverFocus: React.CSSProperties = {
  color: "HighlightText",
};

export const commonHighContrastOutlineHoverFocus: React.CSSProperties = {
  outline: "2px dashed ButtonText",
};

export const commonHighContrastButtonRestStyles: React.CSSProperties = {
  background: "ButtonFace",
  outline: "inherit",
};

export const commonHighContrastColorButtonRest: React.CSSProperties = {
  color: "ButtonText",
};

export const commonHighContrastDisabledStyles: React.CSSProperties = {
  borderColor: "GrayText",
  opacity: "1",
};

export const commonHighContrastColorDisabled: React.CSSProperties = {
  color: "GrayText",
};

export const commonHighContrastFocusedDisabledStyles: React.CSSProperties = {
  background: "Highlight",
  borderColor: "GrayText",
  opacity: "1",
};

export const commonHighContrastColorFocusedDisabled: React.CSSProperties = {
  color: "GrayText",
};

export const commonHighContrastOutlineFocusedDisabled: React.CSSProperties = {
  outline: "2px dotted GrayText",
};

export const commonHighContrastHoveredDisabledStyles: React.CSSProperties = {
  background: "transparent",
};

export const commonHighContrastOutlineToggledOn: React.CSSProperties = {
  borderColor: "Highlight",
  outline: "2px solid ButtonText",
};

export const commonHighContrastBorder: React.CSSProperties = {
  borderColor: "Window",
  outline: "none",
};
